import { UserGridType } from '@app/pcs/models/user-grid-type';
import * as R from 'ramda';

export enum DossierSearchType {
  ADVANCED_SEARCH = 'advancedSearch',
  QUICK_SEARCH = 'quickSearch',
  RECENT_ACTIVITY = 'recentActivity',
  LABELS = 'labels',
  FILTER = 'filter',
  CARRY_FORWARD = 'carryForwardSearch',
  BULK_DOSSIER_PROMOTION = 'bulkDossierPromotionSearch',
  BULK_ACCEPTANCE_INDICATOR_EDIT = 'bulkAcceptanceIndicatorEditSearch',
  BULK_PERMANENT_ACCEPTANCE = 'bulkPermanentAcceptanceSearch',
  BULK_RU_APPOINTMENT = 'bulkRuAppointmentSearch',
  BULK_RU_APPOINTMENT_PROCESSING = 'bulkRuAppointmentProcessingSearch',
  PAP_SEARCH = 'papSearch'
}

type OfSearchType = (type: DossierSearchType) => boolean;
export const ofSearchType = (types: DossierSearchType[]): OfSearchType => R.compose(R.any(R.__, types), R.equals) as OfSearchType;

type GetSearchTitle = (searchType: DossierSearchType) => string;
export const searchTitle: GetSearchTitle = R.cond([
  [R.equals(DossierSearchType.BULK_ACCEPTANCE_INDICATOR_EDIT), R.always('navigation.bulkEditing.acceptanceIndicator')],
  [R.equals(DossierSearchType.BULK_PERMANENT_ACCEPTANCE), R.always('navigation.bulkEditing.permanentAcceptance')],
  [R.equals(DossierSearchType.BULK_DOSSIER_PROMOTION), R.always('navigation.bulkEditing.dossierPromotion')],
  [R.equals(DossierSearchType.BULK_RU_APPOINTMENT), R.always('label.ru.appointment')],
  [R.equals(DossierSearchType.BULK_RU_APPOINTMENT_PROCESSING), R.always('label.ru.appointment.processing')],
  [R.equals(DossierSearchType.CARRY_FORWARD), R.always('carryForward.title')],
  [R.equals(DossierSearchType.FILTER), R.always('general.label.filter')],
  [R.T, R.always('dashborad.advancedSearch')]
]);

type GetNotificationMessage = (searchType: DossierSearchType) => string;
export const notificationMessage: GetNotificationMessage = R.cond([
  [R.equals(DossierSearchType.BULK_ACCEPTANCE_INDICATOR_EDIT), R.always('bulkEditing.acceptanceIndicator.inProgress')],
  [R.equals(DossierSearchType.BULK_PERMANENT_ACCEPTANCE), R.always('bulkEditing.permanentAcceptance.inProgress')],
  [R.equals(DossierSearchType.BULK_DOSSIER_PROMOTION), R.always('bulkEditing.dossierPromotion.inProgress')],
  [R.equals(DossierSearchType.BULK_RU_APPOINTMENT), R.always('bulkEditing.responsibleRu.inProgress')],
  [R.equals(DossierSearchType.BULK_RU_APPOINTMENT_PROCESSING), R.always('bulkEditing.responsibleRu.processing.inProgress')],
  [R.equals(DossierSearchType.CARRY_FORWARD), R.always('carryForward.inProgress')]
]);

type GetUserGridType = (searchType: DossierSearchType) => UserGridType;
export const userGridType: GetUserGridType = R.cond([
  [R.equals(DossierSearchType.LABELS), R.always(UserGridType.Labels)],
  [R.equals(DossierSearchType.RECENT_ACTIVITY), R.always(UserGridType.RecentActivity)],
  [R.equals(DossierSearchType.QUICK_SEARCH), R.always(UserGridType.QuickSearch)],
  [R.equals(DossierSearchType.ADVANCED_SEARCH), R.always(UserGridType.AdvancedSearch)],
  [R.equals(DossierSearchType.BULK_ACCEPTANCE_INDICATOR_EDIT), R.always(UserGridType.BulkAcceptanceIndicatorEdit)],
  [R.equals(DossierSearchType.BULK_PERMANENT_ACCEPTANCE), R.always(UserGridType.BulkPermanentAcceptance)],
  [R.equals(DossierSearchType.BULK_RU_APPOINTMENT), R.always(UserGridType.BulkRuAppointment)],
  [R.equals(DossierSearchType.BULK_RU_APPOINTMENT_PROCESSING), R.always(UserGridType.BulkRuAppointmentProcessing)],
  [R.equals(DossierSearchType.BULK_DOSSIER_PROMOTION), R.always(UserGridType.BulkDossierPromotion)],
  [R.equals(DossierSearchType.CARRY_FORWARD), R.always(UserGridType.CarryForward)]
]);
